import {useContext, useEffect} from 'react';

import {SussdWhatsAppContext} from "../../providers/SussdWhatsAppProvider";
import {useOutletContext} from "react-router-dom";


function WhatsAppScreen(props) {
    const {resetKey} = useContext(SussdWhatsAppContext)
    const {openWhatsApp, closeWhatsApp} = useOutletContext()
    useEffect(() => {
        openWhatsApp()
        return () => {
            closeWhatsApp()
            resetKey()
        }
    }, []);
}

export default WhatsAppScreen;